export default __webpack_public_path__ + "static/media/bonaLarge.572b24ad.jpg";